import { useState } from "react";
import { motion } from "framer-motion";

export default function CorporateROI() {
  const [employees, setEmployees] = useState(500);

  // Basic logic: 20% burnout risk * $50k cost per attrition
  const riskCost = employees * 0.2 * 50000;
  const recovered = riskCost * 0.4; // Nily saves 40%

  return (
    <div className="w-full max-w-md mx-auto p-6 rounded-3xl bg-[var(--glass-bg)] border border-[var(--glass-border)] backdrop-blur-xl shadow-2xl relative overflow-hidden transition-colors duration-700">
      <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 to-teal-500/5 z-0" />

      <div className="relative z-10 space-y-6">
        <div className="text-center space-y-1">
          <h3 className="font-heading text-xl text-[var(--text-main)]">Burnout Risk Calculator</h3>
          <p className="text-xs text-[var(--text-muted)] font-mono uppercase tracking-widest">Nily360 Workplace</p>
        </div>

        {/* Slider */}
        <div className="space-y-4">
          <label className="text-sm text-[var(--text-muted)]">
            Organization Size: <span className="text-[var(--text-main)] font-bold">{employees}</span>
          </label>
          <input
            type="range"
            min="100"
            max="5000"
            step="100"
            value={employees}
            onChange={(e) => setEmployees(Number(e.target.value))}
            className="w-full h-2 rounded-full appearance-none bg-[var(--text-muted)]/20 cursor-pointer accent-[var(--risk-amber)]"
          />
        </div>

        {/* ROI Visualizer */}
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 rounded-xl bg-red-500/10 border border-red-500/20 text-center">
            <div className="text-[10px] text-red-400 uppercase">Risk Exposure</div>
            <div className="text-lg font-mono font-bold text-red-500">${(riskCost / 1000000).toFixed(1)}M</div>
          </div>
          <div className="p-4 rounded-xl bg-[var(--nily-teal)]/10 border border-[var(--nily-teal)]/20 text-center">
            <div className="text-[10px] text-[var(--nily-teal)] uppercase">Recovered by Nily</div>
            <motion.div
              key={employees}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="text-lg font-mono font-bold text-[var(--nily-teal)]"
            >
              ${(recovered / 1000).toFixed(0)}k
            </motion.div>
          </div>
        </div>

        <div className="h-2 w-full bg-[var(--bg-main)]/50 rounded-full overflow-hidden flex">
          <motion.div
            className="h-full bg-red-500"
            initial={{ width: "100%" }}
            animate={{ width: "60%" }}
            transition={{ duration: 1 }}
          />
          <motion.div className="h-full bg-[var(--nily-teal)] flex-grow" />
        </div>
        <p className="text-xs text-center text-[var(--text-muted)]">
          Projected annual recovery based on 40% risk mitigation.
        </p>
      </div>
    </div>
  );
}
